import React from "react";

export function MemberInfoSkeleton() {
    return (
        <div className="bg-white p-6 rounded-lg shadow animate-pulse space-y-4 text-left">
            <div className="h-6 bg-gray-200 rounded w-1/3"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[...Array(8)].map((_, i) => (
                    <div key={i} className="flex items-start py-1 text-xs gap-2">
                        <div className="h-4 bg-gray-200 rounded w-[140px] flex-shrink-0"></div>
                        <div className="h-4 bg-gray-100 rounded flex-1"></div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export function CartSummarySkeleton() {
    return (
        <div className="bg-white p-6 rounded-lg shadow animate-pulse space-y-4 text-left">
            <div className="h-6 bg-gray-200 rounded w-1/4"></div>
            <div className="space-y-3">
                {[...Array(2)].map((_, i) => (
                    <div key={i} className="flex gap-4 items-center border-b pb-3">
                        <div className="w-12 h-16 bg-gray-200 rounded flex-shrink-0"></div>
                        <div className="flex-1 space-y-2">
                            <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                            <div className="h-3 bg-gray-150 rounded w-1/2"></div>
                        </div>
                        <div className="w-16 h-8 bg-gray-200 rounded flex-shrink-0"></div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export function CardSkeleton({ title, rows = 5 }) {
    return (
        <div className="bg-white p-5 border border-gray-200 rounded-lg shadow-xs space-y-4 animate-pulse text-left">
            <h3 className="text-xs font-bold uppercase tracking-wider text-gray-900 border-b pb-2">
                {title}
            </h3>
            <div className="space-y-3">
                {[...Array(rows)].map((_, i) => (
                    <div key={i} className="flex items-start py-1 text-xs gap-2">
                        <div className="h-3.5 bg-gray-200 rounded w-[120px] flex-shrink-0"></div>
                        <div className="h-3.5 bg-gray-100 rounded flex-1"></div>
                    </div>
                ))}
            </div>
        </div>
    );
}
